import React from 'react';

export default function Fieldset(props) {
  const legend = (props.legend) ? <legend>{props.legend}</legend> : null;
  return (<fieldset>{legend}{props.children}</fieldset>);
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Fieldset.jsx